import { Circle, Page } from '@/components';
import { collateralColorPalette } from '@/theme/utils/collateralColorPalette';
import { Flex, Heading } from '@blockanalitica/ui';
import { useTheme } from 'styled-components';
import ExposureKpis from './ExposureKpis';
import IlksTable from './IlksTable';
import OverviewKpis from './OverviewKpis';
import RiskKpis from './RiskKpis';
import CollateralAtRiskTabs from './CollateralAtRiskTabs';

export default function CorePage() {
  const theme = useTheme();

  return (
    <Page
      title={
        <Flex gap="3xs" alignItems="center">
          <Circle
            size="3"
            color={collateralColorPalette(
              'core',
              theme.colors.collateralColors
            )}
          />
          <Heading size="1">Core</Heading>
        </Flex>
      }>
      <OverviewKpis daysAgo={1} />
      <ExposureKpis daysAgo={1} />
      <RiskKpis daysAgo={1} />
      <IlksTable daysAgo={1} />
      <CollateralAtRiskTabs />
    </Page>
  );
}
